import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toRnbApiError } from 'shared'
import type { RnbCalculatorPayload } from 'typings'
import { useFetch } from './useFetch'
import { useLogger } from './useLogger'
import { logRnbErrorCode } from './utils/rnbErrorLog'

type Params = {
  data: Partial<RnbCalculatorPayload>
}

export function usePromotionMutation() {
  const { fetcherWrapper } = useFetch()
  const { logger } = useLogger()
  const queryClient = useQueryClient()

  const mutation = async (params: Params) => {
    const { data } = params

    const url = new URL(
      `/api/proxy/rnb/pvt/calculatorconfiguration/`,
      window.location.origin
    )

    try {
      const response = await fetcherWrapper(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })

      return (await response.json()) as RnbCalculatorPayload
    } catch (error) {
      const apiError = await toRnbApiError(error)

      logRnbErrorCode({ error: apiError, url: url.toString(), logger })

      throw apiError
    }
  }

  const { mutate: save, isPending } = useMutation({
    mutationFn: mutation,
    onSuccess: async (data) => {
      queryClient.setQueryData(
        ['promotion-by-id', data.idCalculatorConfiguration],
        data
      )
      queryClient.refetchQueries({ queryKey: ['active-promotions'] })
    },
  })

  return {
    save,
    isLoading: isPending,
  }
}
